module.exports = __webpack_public_path__ + "img/quailIcons.48927e68.png";